<template>
  <eight-wide-column>
    <segment>
      <div
        class="ui sub header"
        style="margin-top: 1rem;">
        {{ $t('detailsHeader', { itemType: $tc('action', 1)}) }}
      </div>
      <div
        class="ui form"
        style="width: 24.5rem;">
        <!-- Action Details -->
        <p class="truncate">
          <strong>{{ $t('shortName') }}:</strong> {{ item.data.shortName }}
        </p>
        <p class="truncate">
          <strong>{{ $t('startDay') }}:</strong> {{ item.data.options.startDay }}
        </p>
        <p class="truncate">
          <strong>{{ $t('endDay') }}:</strong> {{ item.data.options.endDay }}
        </p>
        <p class="truncate">
          <strong>Tracking?</strong>
        &nbsp;
          <i
            v-if="item.data.options.userTracking.status === true"
            class="green checkmark icon"/>
          <i
            v-else
            class="red close icon"/>
        </p>

        <!-- Affiliation to Action Plans -->
        <p class="truncate">
          <strong>{{ $tc('actions.planAffiliation', affiliatedPlans.length) }}: </strong>
          {{ affiliatedPlans | commaSeparation }}
        </p>

        <!-- Last Modified -->
        <p>
          <i>{{ $tc('actions.lastModified') }} {{ item.data.lastModifiedTime | readableDateFormat }} {{ $tc('actions.localTime') }} {{ item.data.lastModifiedByUser }}</i>
        </p>

        <!-- Edit Button -->
        <router-link :to="{ name: 'ActionEdit', params: { itemId: item.id }}">
          <div class="ui button">
            {{ $t('actions.edit') }}
          </div>
        </router-link>
      </div>
    </segment>
  </eight-wide-column>
</template>

<script>
import EightWideColumn from '../utility/EightWideColumn'
import Segment from '../utility/Segment'

export default {
  name: 'ActionDetails',
  components: { Segment, EightWideColumn },
  props: {
    item: {
      type: Object,
      required: true
    },
    affiliatedPlans: {
      type: Array,
      required: true
    }
  },
  filters: {
    commaSeparation (affiliatedPlans) {
      return (
        affiliatedPlans.length
          ? affiliatedPlans.map(affiliatedPlans => affiliatedPlans.data.title).join(', ')
          : 'None' // TODO: Insert Localization Reference
      )
    },
    readableDateFormat (timestamp) {
      return (
        new Date(timestamp)
          .toLocaleDateString(
            'en',
            {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric'
            }
          )
      )
    }
  }
}
</script>

<style scoped>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
